var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"colorBtn mdi",class:this.$colorMode.preference === 'dark' ? 'mdi-moon-waning-crescent' : 'mdi-white-balance-sunny',attrs:{"title":_vm.$t('footeractions.colormode')},on:{"click":_vm.toggleSwitch}})
}
var staticRenderFns = []

export { render, staticRenderFns }